
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    var link = e.target.closest(".preorder-link");
    if (link) {
      e.preventDefault();
      openPreorderPopup(link);
    }
  });
});

document.addEventListener("click", function (e) {
  var header = e.target.closest(".jdgm-header");
  if (!header) return;
  e.preventDefault();
  window.open("/pages/reviews-human-hair-wigs-toppers", "_blank", "noopener,noreferrer");
});

document.addEventListener("change", function (e) {
  if (!e.target || e.target.name !== "sort_by" || e.target.type !== "radio") return;
  var sortSelect = document.getElementById("SortBy");
  if (sortSelect) sortSelect.value = e.target.value;
});

function openPreorderPopup(trigger) {
  var existing = document.getElementById("preorder-popup");
  if (existing) existing.remove();

  var rect = trigger.getBoundingClientRect();
  var popup = document.createElement("div");
  popup.id = "preorder-popup";
  popup.innerHTML =
    '<div class="preorder-bubble">' +
      '<button class="preorder-close" type="button" aria-label="Close">✕</button>' +
      '<div class="preorder-bubble__header">' +
        '<div class="preorder-bubble__icon">' +
          '<img class="preorder-bubble__avatar" src="https://cdn.shopify.com/s/files/1/0705/9836/1130/files/clem-care-guide.png?v=1776830597" alt="Clem, Goldylost" loading="lazy">' +
        '</div>' +
        '<span class="preorder-bubble__label">Pre-order</span>' +
      '</div>' +
      '<h3>Ships in 10–12 weeks</h3>' +
      '<p>Is the hair you loved out of stock? no problem! You can pre-order the item. In that case, the next hair coming is yours. The wait time can range from 10 to 12 weeks depending how far away are we in producing your hair.</p>' +
    '</div>';

  document.body.appendChild(popup);
  var bubble = popup.querySelector(".preorder-bubble");
  var bubbleWidth = popup.offsetWidth || 360;
  var bubbleHeight = bubble.offsetHeight || 190;
  var left = rect.left + window.scrollX - 18;
  var top = rect.top + window.scrollY - bubbleHeight - 20;
  var maxLeft = window.scrollX + window.innerWidth - bubbleWidth - 12;
  var minLeft = window.scrollX + 12;
  if (left > maxLeft) left = maxLeft;
  if (left < minLeft) left = minLeft;
  if (top < window.scrollY + 12) {
    top = rect.bottom + window.scrollY + 18;
    bubble.classList.add("preorder-bubble--down");
  }
  popup.style.left = left + "px";
  popup.style.top = top + "px";

  var closeBtn = popup.querySelector(".preorder-close");
  function removePopup() {
    if (document.body.contains(popup)) popup.remove();
    document.removeEventListener("click", closeOutsidePopup);
    window.removeEventListener("scroll", closeOnScroll, true);
    window.removeEventListener("resize", closeOnScroll);
  }
  function closeOutsidePopup(e) {
    if (!popup.contains(e.target) && !e.target.classList.contains("preorder-link")) removePopup();
  }
  function closeOnScroll() { removePopup(); }
  closeBtn.onclick = function () { removePopup(); };
  setTimeout(function () { document.addEventListener("click", closeOutsidePopup); }, 10);
  window.addEventListener("scroll", closeOnScroll, true);
  window.addEventListener("resize", closeOnScroll);
}

function capitalizeWords(text) {
  return text.replace(/\b\w/g, function (char) { return char.toUpperCase(); });
}

function formatCartProperties() {

  var labelMap = {
    "choose-pc": "Part Line", "choose-mobile": "Part Line",
    "restyle-pc": "Style", "restyle-mobile": "Style",
    "cutlace-pc": "Lace Cut", "cutlace-mobile": "Lace Cut",
    "agree-pc": "Agreement", "agree-mobile": "Agreement"
  };
  document.querySelectorAll(".cart-item__details").forEach(function (item) {
    var variantDl = item.querySelector("dl:not(.cart-item__properties)");
    if (variantDl && !variantDl.dataset.formatted) {
      var dds = variantDl.querySelectorAll("dd");
      if (dds.length >= 2 && /^(x-?small|extra small|small|medium|large)$/i.test(dds[1].textContent.trim())) {

        var variantValue = capitalizeWords(dds[1].textContent.trim().toLowerCase());
        var newDd = document.createElement("dd");
        newDd.textContent = "Cap Size: " + variantValue;
        variantDl.textContent = "";
        variantDl.appendChild(newDd);
        variantDl.dataset.formatted = "true";
      }
    }
    item.querySelectorAll(".cart-item__property").forEach(function (property) {
      if (property.dataset.formatted === "true") return;
      var titleEl = property.querySelector(".cart-item__property--title");
      var descEl = property.querySelector(".cart-item__property--desc");
      if (!titleEl || !descEl) return;
      var rawKey = titleEl.textContent.replace(":", "").trim().toLowerCase();

      if ((rawKey === "agreement" || rawKey === "agree-pc" || rawKey === "agree-mobile") && property.closest(".cart-drawer")) {
        property.closest("div").remove();
        return;
      }
      var newLabel = labelMap[rawKey];

      if (newLabel === null) {
        property.closest("div").remove();
        return;
      }
      newLabel = newLabel || capitalizeWords(rawKey);
      var value = descEl.textContent.trim().replace(/\s+/g, " ").toLowerCase();
      if (newLabel === "Lace Cut" || rawKey === "cutlace-pc" || rawKey === "cutlace-mobile") {
        if (value.indexOf("yes") === 0 || value === "true") {
          value = "Yes – no returns";
        } else if (value.indexOf("no") === 0 || value === "false") {
          value = "No – leave lace uncut";
        } else {
          value = capitalizeWords(value);
        }
      } else if (value === "yes - no returns" || value === "i agree to the goldylost return policy") {
        value = "True";
      } else {
        value = capitalizeWords(value);
      }
      titleEl.textContent = newLabel + ":";
      descEl.textContent = value;
      property.dataset.formatted = "true";
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  formatCartProperties();
  var cartBody = document.querySelector("#CartDrawer-Body");
  if (!cartBody) return;
  new MutationObserver(function () { formatCartProperties(); }).observe(cartBody, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  function updateBadge(count) {
    var badge = document.querySelector('.wishlist-count-badge');
    if (!badge) return;
    var n = parseInt(count, 10) || 0;
    if (n > 0) {
      badge.textContent = n > 99 ? '+' : String(n);
      badge.classList.remove('hidden');
    } else {
      badge.textContent = '0';
      badge.classList.add('hidden');
    }
  }

  function readSwymCountFromDOM() {
    var el =
      document.querySelector('.swym-header-icon-count[data-count]') ||
      document.querySelector('.swym-header-icon-count') ||
      document.querySelector('.swym-header-launcher-count');
    if (!el) return null;
    var raw = el.getAttribute('data-count') || el.textContent || '';
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function resolveAndUpdate(fetchedCount) {
    var domCount = readSwymCountFromDOM();
    if (domCount !== null) {
      updateBadge(domCount);
    } else if (typeof fetchedCount === 'number') {
      updateBadge(fetchedCount);
    }
  }

  function launchSwymWishlist(e) {
    var trigger =
      document.querySelector('#swym-advanced-header-icon[data-swym-click-attached="true"]') ||
      document.querySelector('#swym-advanced-header-icon') ||
      document.querySelector('.swym-advanced-header-icon') ||
      document.querySelector('#swym-release-header-inject') ||
      document.querySelector('.swym-header-launcher:not([data-wishlist-launcher] *)');

    if (trigger) {
      e.preventDefault();
      var evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
      trigger.dispatchEvent(evt);
      return;
    }

    try {
      if (window._swat && window._swat.ui && typeof window._swat.ui.loadScreen === 'function') {
        e.preventDefault();
        window._swat.ui.loadScreen('wishlist');
      }
    } catch (_) {}
  }

  function hideSwymFromA11y() {
    document.querySelectorAll([
      '.header__utils-items .swym-header-launcher',
      '.header__utils-items #swym-release-header-inject',
      '.header__utils-items [id^="swym-release-header"]',
      '.header__utils-items .swym-advanced-header-icon',
      '.header__utils-items .swym-header-icon-wrapper'
    ].join(',')).forEach(function (el) {
      if (!el.hasAttribute('aria-hidden')) el.setAttribute('aria-hidden', 'true');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    });
  }

  var launcher = document.querySelector('[data-wishlist-launcher] > a');
  if (launcher) launcher.addEventListener('click', launchSwymWishlist);
  hideSwymFromA11y();

  function initSwymBridge() {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      function refresh() {
        try {
          swat.fetch(function (items) {
            resolveAndUpdate(Array.isArray(items) ? items.length : 0);
          });
        } catch (_) {
          resolveAndUpdate();
        }
      }
      refresh();
      try {
        var evt = swat.JSEvents || {};
        var layer = swat.evtLayer || document;
        if (evt.addedToWishlist) layer.addEventListener(evt.addedToWishlist, refresh);
        if (evt.removedFromWishlist) layer.addEventListener(evt.removedFromWishlist, refresh);
      } catch (_) {}
    });

    var headerUtils = document.querySelector('.header__utils-items') || document.body;
    var domSyncTimer;
    new MutationObserver(function () {
      if (domSyncTimer) return;
      domSyncTimer = setTimeout(function () {
        domSyncTimer = null;
        var n = readSwymCountFromDOM();
        if (n !== null) updateBadge(n);
        hideSwymFromA11y();
      }, 120);
    }).observe(headerUtils, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-count'],
      characterData: true,
    });
  }

  function scheduleSwymInit() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(initSwymBridge, { timeout: 5000 });
    } else {

      setTimeout(initSwymBridge, 200);
    }
  }

  if (document.readyState === 'complete') {
    scheduleSwymInit();
  } else {
    window.addEventListener('load', scheduleSwymInit, { once: true });
  }
});

const COLLECTION_VIDEO_MAP = {
  '/collections/human-hair-wigs':
    'https://cdn.shopify.com/videos/c/o/v/503e907529fb40779e38468054e0cec4.mp4',
  '/collections/wigs-sydney':
    'https://cdn.shopify.com/videos/c/o/v/503e907529fb40779e38468054e0cec4.mp4',
  '/collections/virgin-hair-wigs':
    'https://cdn.shopify.com/videos/c/o/v/249824c6f23c4dc8a3fd3e48252f4c76.mp4',
  '/collections/virgin-hair-toppers':
    'https://cdn.shopify.com/videos/c/o/v/249824c6f23c4dc8a3fd3e48252f4c76.mp4',
  '/collections/lace-wigs':
    'https://cdn.shopify.com/videos/c/o/v/503e907529fb40779e38468054e0cec4.mp4',
  '/collections/hand-tied-wigs':
    'https://cdn.shopify.com/videos/c/o/v/90e7b41fc93843ca97b46ccd558caa60.mp4',
  '/collections/lace-toppers':
    'https://cdn.shopify.com/videos/c/o/v/2e376e2e6bd5454893395da46b32c8fc.mp4',
  '/collections/pony-wigs':
    'https://cdn.shopify.com/videos/c/o/v/8538d6673f8c491f9dc322fc7596abfe.mp4',
  '/collections/hair-toppers':
    'https://cdn.shopify.com/videos/c/o/v/2e376e2e6bd5454893395da46b32c8fc.mp4',
  '/collections/silk-toppers':
    'https://cdn.shopify.com/videos/c/o/v/63e9a39945954a37bf5780ff16fa2364.mp4',
};

document.addEventListener('DOMContentLoaded', () => {
  const videoSrc = COLLECTION_VIDEO_MAP[window.location.pathname];
  if (!videoSrc) return;

  setTimeout(() => {
    const textCard = document.querySelector('.block-text_card_J6n8hm');

    if (textCard) {
      let videoMounted = false;
      const mountVideo = () => {
        if (videoMounted) return;
        videoMounted = true;

      const video = document.createElement('video');
      video.src = videoSrc;
      video.preload = 'metadata';
      video.autoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
        !(navigator.connection && navigator.connection.saveData);
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.style.cssText = `
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        border-radius: 2.4rem;
        cursor: pointer;
      `;

      textCard.style.cssText = `
        position: relative;
        border-radius: 2.4rem;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        width: 100%;
        height: 100%;
      `;

      let userPaused = false;
      video.addEventListener('click', () => {
        if (video.paused || video.ended) {
          userPaused = false;
          video.play().catch(() => {});
        } else {
          userPaused = true;
          video.pause();
        }
      });

      if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!userPaused && video.paused) {
                video.play().catch(() => {});
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { threshold: 0.25 }).observe(video);
      }

      const playOverlay = document.createElement('div');
      playOverlay.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.55);
        color: #fff;
        display: none;
        align-items: center;
        justify-content: center;
        pointer-events: none;
        z-index: 2;
      `;
      playOverlay.innerHTML =
        '<svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true">' +
        '<path d="M8 5v14l11-7z"/></svg>';
      video.addEventListener('play', () => { playOverlay.style.display = 'none'; });
      video.addEventListener('pause', () => { playOverlay.style.display = 'flex'; });
      video.addEventListener('ended', () => { playOverlay.style.display = 'flex'; });

      const muteBtn = document.createElement('button');
      muteBtn.type = 'button';
      muteBtn.setAttribute('aria-label', 'Toggle sound');
      muteBtn.style.cssText = `
        position: absolute;
        top: 14px;
        right: 14px;
        width: 38px;
        height: 38px;
        border: none;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.55);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        z-index: 3;
        transition: background 0.2s ease;
      `;
      const ICON_MUTED =
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M11 5 6 9H2v6h4l5 4z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
      const ICON_SOUND =
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';
      muteBtn.innerHTML = ICON_MUTED;
      muteBtn.addEventListener('mouseenter', () => { muteBtn.style.background = 'rgba(0,0,0,0.72)'; });
      muteBtn.addEventListener('mouseleave', () => { muteBtn.style.background = 'rgba(0,0,0,0.55)'; });
      muteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        muteBtn.innerHTML = video.muted ? ICON_MUTED : ICON_SOUND;
      });

      textCard.innerHTML = '';
      textCard.appendChild(video);
      textCard.appendChild(playOverlay);
      textCard.appendChild(muteBtn);

        if (video.autoplay) video.play().catch(() => {});
        else playOverlay.style.display = 'flex';
      };

      if (typeof IntersectionObserver !== 'undefined') {
        const mountObserver = new IntersectionObserver((entries, observer) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          mountVideo();
        }, { rootMargin: '300px 0px', threshold: 0.01 });
        mountObserver.observe(textCard);
      } else {
        mountVideo();
      }
    }
  }, 300);
});

(function () {
  var SELECTOR = ".jdgm-cards-carousel .jdgm-media-card img";

  function applyFit(img) {
    if (img.dataset.fitChecked) return;

    if (!img.hasAttribute("alt") || img.getAttribute("alt").trim() === "") {
      img.setAttribute("alt", "Customer review photo");
    }

    if (!img.complete || !img.naturalWidth) {
      img.addEventListener("load", function () { applyFit(img); }, { once: true });
      img.addEventListener("error", function () { img.dataset.fitChecked = "1"; }, { once: true });
      return;
    }
    img.dataset.fitChecked = "1";

    var card = img.closest(".jdgm-media-card") || img.parentElement;
    if (!card) return;
    var cardW = card.clientWidth;
    var cardH = card.clientHeight;
    if (!cardW || !cardH) return;

    var imgRatio = img.naturalWidth / img.naturalHeight;
    var cardRatio = cardW / cardH;

    if (imgRatio >= cardRatio * 0.8) {
      img.dataset.fit = "cover";
    } else {
      img.removeAttribute("data-fit");
    }
  }

  function processAll() {
    document.querySelectorAll(SELECTOR).forEach(applyFit);
  }

  function init() {
    processAll();
    var carousel = document.querySelector(".jdgm-cards-carousel");
    var target = carousel || document.body;
    new MutationObserver(function (mutations) {
      var hasNewImg = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (n.matches && (n.matches(SELECTOR) || n.querySelector(SELECTOR)));
        });
      });
      if (hasNewImg) processAll();
    }).observe(target, { childList: true, subtree: true });

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll(SELECTOR).forEach(function (img) {
          delete img.dataset.fitChecked;
          applyFit(img);
        });
      }, 200);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  var strings = window.actionStrings || {};
  var SHOW_MORE = strings.showMore || "Read more";
  var SHOW_LESS = strings.showLess || "Read less";

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".section-page-banner__toggle");
    if (!btn) return;
    var content = btn.closest(".section-page-banner__content");
    var block = content && content.querySelector(".section-page-banner__text");
    if (!block) return;
    var section = btn.closest(".section-page-banner");

    var expanded = block.classList.toggle("is-expanded");
    if (section) section.classList.toggle("is-banner-expanded", expanded);
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    btn.textContent = expanded ? SHOW_LESS : SHOW_MORE;
  });

  function setupBlock(block) {
    if (block.dataset.collapseInited) return;
    block.dataset.collapseInited = "1";

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "section-page-banner__toggle";
    btn.textContent = SHOW_MORE;
    btn.setAttribute("aria-expanded", "false");
    btn.hidden = true;
    block.parentNode.insertBefore(btn, block.nextSibling);

    requestAnimationFrame(function () {
      if (block.scrollHeight > block.clientHeight + 4) {
        btn.hidden = false;
      }
    });
  }

  function init() {
    document.querySelectorAll(".section-page-banner__text").forEach(setupBlock);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  var GOOGLE_RATING = '4.9';
  function glJdgmShopTotal() {
    var s = document.getElementsByTagName('script');
    for (var i = 0; i < s.length; i++) {
      var t = s[i].textContent;
      var m = t && t.match(/shop_aggregates\s*:\s*\{\s*reviewCount\s*:\s*(\d+)/);
      if (m) return m[1];
    }
    return null;
  }
  var RATING_RX = /[45](\.\d+)?/;
  function glApplyJdgmCarousel() {
    var total = glJdgmShopTotal();
    var carousels = document.querySelectorAll('.jdgm-cards-carousel');
    for (var i = 0; i < carousels.length; i++) {
      var c = carousels[i];
      var countEl = c.querySelector('.jdgm-reviews-count');
      if (total && countEl && countEl.textContent.trim() !== total) countEl.textContent = total;
      var rt = c.querySelector('.jdgm-rating-text');
      if (rt) {
        for (var n = 0; n < rt.childNodes.length; n++) {
          var node = rt.childNodes[n];
          var m = node.nodeType === 3 ? node.nodeValue.match(RATING_RX) : null;
          if (m) {
            if (m[0] !== GOOGLE_RATING) node.nodeValue = node.nodeValue.replace(RATING_RX, GOOGLE_RATING);
            break;
          }
        }
      }
      var stars = c.querySelector('.jdgm-average-rating .jdgm-stars[aria-label]');
      if (stars) {
        var al = stars.getAttribute('aria-label') || '';
        var am = al.match(RATING_RX);
        if (am && am[0] !== GOOGLE_RATING) stars.setAttribute('aria-label', al.replace(RATING_RX, GOOGLE_RATING));
      }
      glClampCards(c);
    }
  }
  function glClampCards(carousel) {
    var cards = carousel.querySelectorAll('.jdgm-card');
    for (var k = 0; k < cards.length; k++) {
      var card = cards[k];
      var textBox = card.querySelector('.jdgm-text');
      var ps = textBox ? textBox.querySelectorAll('p') : [];
      var p = ps[0];
      if (!p || !p.clientHeight) continue;
      var lineH = parseFloat(getComputedStyle(p).lineHeight) || 19.2;
      var truncated = p.scrollHeight > lineH * 2 + 4 || ps.length > 1;
      var isMarked = card.classList.contains('gl-clamped');
      if (truncated && !isMarked) {
        card.classList.add('gl-clamped');
        if (!textBox.querySelector('.gl-readmore')) {
          var chip = document.createElement('span');
          chip.className = 'gl-readmore';
          chip.setAttribute('aria-hidden', 'true');
          chip.textContent = 'Read more';
          textBox.appendChild(chip);
        }
      } else if (!truncated && isMarked) {
        card.classList.remove('gl-clamped');
        var old = textBox.querySelector('.gl-readmore');
        if (old) old.parentNode.removeChild(old);
      }
    }
  }
  function glInitJdgmCarousel() {
    glApplyJdgmCarousel();
    var tries = 0;
    var timer = setInterval(function () {
      glApplyJdgmCarousel();
      if (++tries > 40) clearInterval(timer);
    }, 500);
    var obs = new MutationObserver(glApplyJdgmCarousel);
    var cs = document.querySelectorAll('.jdgm-cards-carousel');
    for (var j = 0; j < cs.length; j++) obs.observe(cs[j], { childList: true, subtree: true });
    window.addEventListener('load', glApplyJdgmCarousel);
    var rzt;
    window.addEventListener('resize', function () {
      clearTimeout(rzt);
      rzt = setTimeout(glApplyJdgmCarousel, 250);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', glInitJdgmCarousel);
  else glInitJdgmCarousel();
})();

(function () {
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || el.name !== 'filter.p.m.custom.in_stock' || !el.checked) return;
    var scope = el.form || document;
    var inputs = scope.querySelectorAll('input[name="filter.p.m.custom.in_stock"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i] !== el && inputs[i].value !== el.value && inputs[i].checked) inputs[i].checked = false;
    }
  });
})();

(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[id^="country-drawer-button"]');
    if (t) {
      var hd = document.querySelector('header-drawer details');
      if (hd) { hd.removeAttribute('open'); hd.classList.remove('menu-opening'); }
    }
  });
})();

(function () {
  var MOBILE_BREAKPOINT = 768;
  var AUTOPLAY_THRESHOLD = 0.55;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function prepareInlineAutoplay(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
    video.removeAttribute('controls');
  }

  function hydrate(video) {
    var source = video.querySelector('source[data-src]');
    if (!source) return false;
    source.src = source.getAttribute('data-src');
    source.removeAttribute('data-src');
    video.load();
    return true;
  }

  function playMutedInline(video) {
    if (!video || reducedMotion()) return;
    prepareInlineAutoplay(video);
    var justHydrated = hydrate(video);
    var attempt = function () {
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(function () {});
    };
    attempt();
    if (justHydrated && video.readyState < 2) {
      video.addEventListener('canplay', attempt, { once: true });
    }
  }

  function visibleRatio(video) {
    var rect = video.getBoundingClientRect();
    if (!rect.width || !rect.height) return 0;
    var visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    return (visibleWidth * visibleHeight) / (rect.width * rect.height);
  }

  function initHomeVideoAutoplay() {
    var transformationVideos = Array.prototype.slice.call(
      document.querySelectorAll('.transformation-section .video-wrapper video')
    );

    if (window.innerWidth <= MOBILE_BREAKPOINT && transformationVideos.length && !reducedMotion()) {
      var startVisibleVideo = function (video) {
        transformationVideos.forEach(function (other) {
          if (other !== video && !other.paused) other.pause();
        });
        playMutedInline(video);
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= AUTOPLAY_THRESHOLD) {
              startVisibleVideo(entry.target);
            } else if (!entry.isIntersecting || entry.intersectionRatio < 0.35) {
              entry.target.pause();
            }
          });
        }, { threshold: [0, 0.35, AUTOPLAY_THRESHOLD, 1] });
        transformationVideos.forEach(function (video) { observer.observe(video); });
      } else {
        var firstVideo = transformationVideos[0];
        if (firstVideo) startVisibleVideo(firstVideo);
      }

      var resumeVisibleTransformationVideo = function () {
        if (document.hidden) return;
        var best = null;
        var bestRatio = 0;
        transformationVideos.forEach(function (video) {
          var ratio = visibleRatio(video);
          if (ratio > bestRatio) {
            best = video;
            bestRatio = ratio;
          }
        });
        if (best && bestRatio >= AUTOPLAY_THRESHOLD) startVisibleVideo(best);
      };
      window.addEventListener('pageshow', resumeVisibleTransformationVideo);
      document.addEventListener('visibilitychange', resumeVisibleTransformationVideo);
    }

    var heroVideos = document.querySelectorAll('.hero__media video[autoplay]');
    var resumeVisibleHeroVideos = function () {
      for (var i = 0; i < heroVideos.length; i++) {
        if (heroVideos[i].getClientRects().length) playMutedInline(heroVideos[i]);
      }
    };
    resumeVisibleHeroVideos();

    window.addEventListener('pageshow', function () {
      if (document.hidden) return;
      resumeVisibleHeroVideos();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeVideoAutoplay);
  } else {
    initHomeVideoAutoplay();
  }
})();
